export default __webpack_public_path__ + "static/media/about1.5eb55b25.png";